import { render, staticRenderFns } from "./TireDialogTabsExpansion.vue?vue&type=template&id=638b2908&"
import script from "./TireDialogTabsExpansion.vue?vue&type=script&lang=js&"
export * from "./TireDialogTabsExpansion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports